import React, { useState } from "react";
import "../profile/profile.css";
import { Tabs } from "antd";
import SubjectStatetistics from "./SubjectStatetistics.js";
import DashboardWrapper from "../shared/DashboardWrapper.js";

const Statistics = () => {
  const [tabKey, setTabKey] = useState("Mathematics");

  return (
    <DashboardWrapper title="MY STATISTICS">
      <div className="tabs">
        <Tabs
          activeKey={tabKey}
          onChange={setTabKey}
          items={[
            {
              key: "Mathematics",
              label: "MATHEMATICS",
              children: <SubjectStatetistics title="Mathematics" />,
            },
            {
              key: "English",
              label: "ENGLISH",
              children: <SubjectStatetistics title="English" />,
            },
            {
              key: "Science",
              label: "SCIENCE",
              children: <SubjectStatetistics title="Science" />,
            },
            {
              key: "MotherTongue",
              label: "MOTHER TONGUE",
              children: <p>No data available</p>,
            },
          ]}
          tabBarStyle={{
            borderBottom: "none",
          }}
        />
      </div>
    </DashboardWrapper>
  );
};

export default Statistics;
